<template>
  <div class="contaier">
    <div class="box md:flex md:justify-between">
      <!-- <p>tel: +852 7072 8028</p> -->
      <a href="tel:852 7072 8028">WhatsApp: +852 7072 8028</a>
      <p>© iCAUR Hong Kong 2026 All rights reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterPage",
};
</script>
<style lang="scss" scoped>
.contaier {
  padding: 30px 20px;
  border-top: 1px solid #ddd;
  background-color: #fafafa;

  .box {
    max-width: 1200px;
    // max-width: 1240px;
    margin: 0 auto;
    font-size: 12px;
    line-height: 30px;
    // color: #fff;
  }
}
</style>
